export interface FilterTag {
  label: string;
  exclude: boolean;
}

export function parseQuery(queryToParse?: string): FilterTag[] {
  const parsedTags: FilterTag[] = [];

  if (!queryToParse) {
    return parsedTags;
  } else {
    queryToParse.split('&').forEach((token) => {
      if (token.startsWith('-')) {
        parsedTags.push({
          exclude: true,
          label: token.slice(2, -1),
        });
      } else {
        parsedTags.push({
          exclude: false,
          label: token.slice(1, -1),
        });
      }
    });
    return parsedTags;
  }
}

export function serializeQuery(tagsToSerialize: FilterTag[] = [], escaped?: boolean): string {
  return tagsToSerialize && tagsToSerialize.length > 0
    ? tagsToSerialize
        .map((tag) => {
          return `${tag.exclude ? '-' : ''}*${tag.label}*`;
        })
        .join(escaped ? '%26' : '&')
    : '';
}
